const obtenirValorsVariablesAutomatiques = (variables, estacio) => {

    let valorsVariablesAutomatiques = [];

    valorsVariablesAutomatiques.push(calcularPressioReduidaNivellDelMar(variables, estacio));
    valorsVariablesAutomatiques.push(calcularHoresDeSolTotals(variables));
    valorsVariablesAutomatiques.push(calcularPrecipitacioTotalDarreres24hDiaCivil(variables));

    return valorsVariablesAutomatiques.filter(calculVariableAutomatica => calculVariableAutomatica !== null);
};

const obtenirVariable = (variables, idVariableBuscada) => {

    let variableBuscada;

    Object.keys(variables).forEach(indexGrup => {

        if (variableBuscada) {
            return;
        }

        const grupVariables = variables[indexGrup];

        grupVariables.forEach(variable => {
            if (variable.idVariable === idVariableBuscada) {
                variableBuscada = variable;
            }
        });

    });

    return variableBuscada;
};

const obtenirValorVariable = (variable) => {

    if (!variable) {
        return null;
    }

    let valorVariable;

    if (variable.hasOwnProperty('valorNou')) {
        valorVariable = variable.valorNou;
    } else if (variable.hasOwnProperty('valor')) {
        valorVariable = variable.valor;
    } else {
        valorVariable = null;
    }

    // Transformem els valors numèrics de String a Number per tal de poder
    // fer els càlculs necessaris
    if (variable.tipus === 'Numeric' && valorVariable != null) {
        valorVariable = parseFloat(valorVariable);
    }

    return valorVariable;
};

const calcularValorPressioReduidaNivellDelMar = (temperatura, humitat, pressio, estacio) => {

    let valorPressioReduida = null;
    const altitudEstacio = estacio.altitud;

    if (temperatura === null || pressio === null || altitudEstacio === null || altitudEstacio === undefined) {
        return null;
    }

    if (humitat === null) {
        const z0 = (altitudEstacio >= 1500.0)? 1500.0 : 0.0;
        const num = 0.0065 * (altitudEstacio - z0);
        const deu = temperatura + 273.15 + 0.0065 * (altitudEstacio - z0);
        const b = 1.0 - (num / deu);
        valorPressioReduida =  pressio * Math.pow(b, -5.25593236);
    } else {
        const z0 = (altitudEstacio >= 1500.0)? 1500.0 : 0.0;
        const n = 0.014837 * (altitudEstacio - z0);
        const a = temperatura + 273.15;
        const expo = (7.50 * temperatura) / (237.3 + temperatura);
        const b = 1.0 + 0.023008748 * (humitat / pressio) * Math.pow(10, expo);
        const d = 0.00325 * (altitudEstacio - z0);
        valorPressioReduida = pressio * Math.pow(10, n / (a * b + d));
    }

    return parseFloat(valorPressioReduida.toFixed(1));
};

const calcularValorVariableAcumulativa = (valorOriginal, valorsFranges) => {

    if (valorsFranges.every(valorFranja => valorFranja === null)) {
        //Si cap de les franges està informada, el càlcul no és automàtic
        return valorOriginal;
    }

    if (valorsFranges.some(valorFranja => valorFranja === null)) {
        //Si alguna de les franges està informada, totes ho han d'estar. Si
        //no és el cas es força el valor a null
        return null;
    }

    return valorsFranges.reduce((valorTotal, valorFranja) => valorTotal + valorFranja);

};

const calcularPressioReduidaNivellDelMar = (variables, estacio) => {

    const idVariableTemperaturaTermometreSec = 1;
    const idVariableHumitat = 3;
    const idVariableLecturaDelBarometre = 23;
    const idVariablePressioReduidaNivellDelMar = 86;

    const variableTemperaturaTermometreSec = obtenirVariable(variables, idVariableTemperaturaTermometreSec);
    const variableHumitat = obtenirVariable(variables, idVariableHumitat);
    const variableLecturaBarometre = obtenirVariable(variables, idVariableLecturaDelBarometre);

    const valorVariableTemperaturaTermometreSec = obtenirValorVariable(variableTemperaturaTermometreSec);
    const valorVariableHumitat = obtenirValorVariable(variableHumitat);
    const valorVariableLecturaBarometre = obtenirValorVariable(variableLecturaBarometre);
    const valorVariablePressioReduidaNivellDelMar = calcularValorPressioReduidaNivellDelMar(valorVariableTemperaturaTermometreSec, valorVariableHumitat, valorVariableLecturaBarometre, estacio);

    return {
        idVariable: idVariablePressioReduidaNivellDelMar,
        valor: valorVariablePressioReduidaNivellDelMar,
        esValorCalculAutomatic: true
    };
};

const calcularHoresDeSolTotals = (variables) => {

    const idVariableHoresDeSolTotals = 29;
    const idVariableHoresDeSolEntre00i07h = 30;
    const idVariableHoresDeSolEntre07i13h = 31;
    const idVariableHoresDeSolEntre13i18h = 32;
    const idVariableHoresDeSolEntre18i24h = 33;

    const variableHoresDeSolEntre00i07h = obtenirVariable(variables, idVariableHoresDeSolEntre00i07h);
    const variableHoresDeSolEntre07i13h = obtenirVariable(variables, idVariableHoresDeSolEntre07i13h);
    const variableHoresDeSolEntre13i18h = obtenirVariable(variables, idVariableHoresDeSolEntre13i18h);
    const variableHoresDeSolEntre18i24h = obtenirVariable(variables, idVariableHoresDeSolEntre18i24h);
    const variableHoresDeSolTotals = obtenirVariable(variables, idVariableHoresDeSolTotals);

    const valorVariableHoresDeSolEntre00i07h = obtenirValorVariable(variableHoresDeSolEntre00i07h);
    const valorVariableHoresDeSolEntre07i13h = obtenirValorVariable(variableHoresDeSolEntre07i13h);
    const valorVariableHoresDeSolEntre13i18h = obtenirValorVariable(variableHoresDeSolEntre13i18h);
    const valorVariableHoresDeSolEntre18i24h = obtenirValorVariable(variableHoresDeSolEntre18i24h);
    const valorOriginalVariableHoresDeSolTotals = obtenirValorVariable(variableHoresDeSolTotals);
    const valorsHoresDeSolFranges = [
        valorVariableHoresDeSolEntre00i07h,
        valorVariableHoresDeSolEntre07i13h,
        valorVariableHoresDeSolEntre13i18h,
        valorVariableHoresDeSolEntre18i24h
    ];

    const valorVariableHoresDeSolTotals = calcularValorVariableAcumulativa(valorOriginalVariableHoresDeSolTotals, valorsHoresDeSolFranges);
    return {
        idVariable: idVariableHoresDeSolTotals,
        valor: valorVariableHoresDeSolTotals,
        esValorCalculAutomatic: valorsHoresDeSolFranges.some(valorFranja => valorFranja !== null)
    };
};

const calcularPrecipitacioTotalDarreres24hDiaCivil = (variables) => {

    const idVariablePrecipitacioTotalDarreres24hDiaCivil = 35;
    const idVariablePrecipitacioEntre00i07h = 36;
    const idVariablePrecipitacioEntre07i13h = 37;
    const idVariablePrecipitacioEntre13i18h = 38;
    const idVariablePrecipitacioEntre18i24h = 39;

    const variablePrecipitacioEntre00i07h = obtenirVariable(variables, idVariablePrecipitacioEntre00i07h);
    const variablePrecipitacioEntre07i13h = obtenirVariable(variables, idVariablePrecipitacioEntre07i13h);
    const variablePrecipitacioEntre13i18h = obtenirVariable(variables, idVariablePrecipitacioEntre13i18h);
    const variablePrecipitacioEntre18i24h = obtenirVariable(variables, idVariablePrecipitacioEntre18i24h);
    const variablePrecipitacioTotalDarreres24hDiaCivil = obtenirVariable(variables, idVariablePrecipitacioTotalDarreres24hDiaCivil);

    const valorVariablePrecipitacioEntre00i07h = obtenirValorVariable(variablePrecipitacioEntre00i07h);
    const valorVariablePrecipitacioEntre07i13h = obtenirValorVariable(variablePrecipitacioEntre07i13h);
    const valorVariablePrecipitacioEntre13i18h = obtenirValorVariable(variablePrecipitacioEntre13i18h);
    const valorVariablePrecipitacioEntre18i24h = obtenirValorVariable(variablePrecipitacioEntre18i24h);
    const valorOriginalPrecipitacioTotalDarreres24hDiaCivil = obtenirValorVariable(variablePrecipitacioTotalDarreres24hDiaCivil);
    const valorsPrecipitacioFranges = [
        valorVariablePrecipitacioEntre00i07h,
        valorVariablePrecipitacioEntre07i13h,
        valorVariablePrecipitacioEntre13i18h,
        valorVariablePrecipitacioEntre18i24h
    ];

    const valorVariablePrecipitacioTotalDarreres24hDiaCivil = calcularValorVariableAcumulativa(valorOriginalPrecipitacioTotalDarreres24hDiaCivil, valorsPrecipitacioFranges);
    return {
        idVariable: idVariablePrecipitacioTotalDarreres24hDiaCivil,
        valor: valorVariablePrecipitacioTotalDarreres24hDiaCivil,
        esValorCalculAutomatic: valorsPrecipitacioFranges.some(valorFranja => valorFranja !== null)
    };

};

export default obtenirValorsVariablesAutomatiques;




// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/calculsAutomatics/index.js